import {
  extractPerfectlyMatchingResults,
  extractSimilarJobs,
  parseQueryForGetJobs,
} from '@/utils/jobListingHelper';
import { GetServerSidePropsContext } from 'next';
import { NextSeo } from 'next-seo';
import { GetServerSidePropsResult } from 'next/types';
import React from 'react';
import { getJobSpecialities } from 'services/cmsService';
import { getJobs } from 'services/jobService';
import {
  IJobDetail,
  IJobSpeciality,
  JobListPaginatedResults,
  JobSearchWebCriteria,
} from 'types/jobs';

import JobListing from 'modules/JobListing';
import { ContainerStyle, UserLoggedinContainer } from 'modules/UserLoggedinContainer';

import styles from './style.module.scss';

interface JobsListProps {
  jobs: JobListPaginatedResults;
  similarJobs: IJobDetail[];
  jobSpecialities: IJobSpeciality[];
  query: JobSearchWebCriteria;
}

const JobsList = ({ jobs, query, jobSpecialities, similarJobs }: JobsListProps) => {
  const title = 'Search all doctor jobs in Australia & NZ';
  const description = `Find your next doctor job with Medrecruit. ${jobs.total} jobs available across Australia and NZ. Find better experiences & better pay. Free end to end service for doctors.`;

  return (
    <UserLoggedinContainer
      size={'lg'}
      className={styles.jobListContainer}
      style={ContainerStyle.TINY_BLUE_BANNER}
    >
      <NextSeo
        canonical={'list'}
        title={title}
        description={description}
        openGraph={{
          title,
          description,
        }}
      />
      <JobListing
        jobs={jobs}
        query={query}
        jobSpecialities={jobSpecialities}
        similarJobs={similarJobs}
      />
    </UserLoggedinContainer>
  );
};

export async function getServerSideProps(
  ctx: GetServerSidePropsContext,
): Promise<GetServerSidePropsResult<JobsListProps>> {
  const { query } = ctx;

  const convertedQuery = parseQueryForGetJobs(query);

  const [jobs, jobSpecialities] = await Promise.all([
    getJobs(convertedQuery, ctx) as Promise<JobListPaginatedResults>,
    getJobSpecialities(),
  ]);

  return {
    props: {
      jobs: extractPerfectlyMatchingResults(jobs),
      similarJobs: extractSimilarJobs(jobs.data),
      query,
      jobSpecialities: jobSpecialities ?? [],
    },
  };
}

export default JobsList;
